module.exports = __webpack_public_path__ + "static/media/loading.50a81785.gif";